import React from "react";
import { Link } from "react-router-dom";
import { XCircle, Home, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen bg-navy-900 flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl p-10 max-w-md w-full text-center shadow-2xl">
        <div className="h-20 w-20 rounded-full bg-slate-100 flex items-center justify-center mx-auto mb-5"><XCircle className="h-12 w-12 text-slate-400" /></div>
        <h1 className="font-display text-2xl font-bold text-navy-900">Donation canceled</h1>
        <p className="text-slate-600 mt-3">No charge was made. We're grateful for any support you can offer.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <Link to="/donate"><Button className="rounded-full bg-gold hover:bg-gold-light text-white"><Heart className="h-4 w-4 mr-2" /> Try Again</Button></Link>
          <Link to="/"><Button variant="outline" className="rounded-full"><Home className="h-4 w-4 mr-2" /> Home</Button></Link>
        </div>
      </div>
    </main>
  );
}
